export default [
  'albane@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'flavia@foodforjoe.com',
  'diego@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
